export class TipoUsuario {
    id: number;
    nombre: string;
    gestionUsuarios: number;
  
    constructor(id: number, nombre: string, gestionUsuarios: number) {
      this.id = id;
      this.nombre = nombre;
      this.gestionUsuarios = gestionUsuarios;
    }
  }
  